import styled from 'styled-components';
import { saasModernTheme } from 'common/theme/saasModern';
import { Box, Typography } from '@mui/material';

export const UseCaseWrapper = styled.div`
  padding: ${saasModernTheme.space[4]}px;
  background-color: ${saasModernTheme.colors.background};
`;

export const UseCaseHeader = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  margin-bottom: ${saasModernTheme.space[5]}px;
`;
export const HeadlineStyle = styled(Typography)`
  text-align: center;
  font-size: 48px;
  font-family: ${saasModernTheme.fontFamily};
  font-weight: 900;
  color: var(--Text-Primary, #111927);

  strong {
    background: ${saasModernTheme.customColor.backgroundTextGradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  @media screen and(max-width: 950px) {
    font-size: 38px;
  }
  @media screen and (max-width: 600px) {
    font-size: 30px;
  }
`;

export const Subtitle = styled.p`
  color: var(--Text-Secondary, #636f81);
  font-family: 'Roboto', sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.5;
`;

export const CategoriesWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${saasModernTheme.space[4]}px;
  width: 100%;

  /* À partir de 1200px ou moins, on autorise le wrap */
  @media screen and (max-width: 1200px) {
    flex-wrap: wrap;
    gap: 16px;
    justify-content: center; /* optionnel pour meilleur alignement */
  }

  /* Et pour le mobile, on garde la colonne */
  @media screen and (max-width: 740px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const CategoryButton = styled.button`
  flex: 1;
  padding: 8px 16px;
  border-radius: 20px;
  border: none;
  font-family: ${saasModernTheme.fontFamily};
  cursor: pointer;
  background-color: ${(props) =>
    props.active
      ? 'var(--Background-Default, #111927)'
      : 'var(--Action-Selected, rgba(145, 155, 171, 0.16))'};
  color: ${(props) => (props.active ? '#FFF' : '#000')};
  transition: all 0.3s ease;
  white-space: nowrap;
  text-align: center;

  &:not(:last-child) {
    margin-right: 16px;
  }

  &:hover {
    box-shadow: ${saasModernTheme.gradiantShadow};
    border: 2px solid ${saasModernTheme.customColor.gradiantColor};
    background-color: var(--Action-Selected, rgba(145, 155, 171, 0.16));
    color: #000;
  }

  @media screen and (max-width: 1400px) {
    font-size: 12px;
    padding: 6px 12px;
  }

  @media screen and (max-width: 1200px) {
    flex: 0;
  }

  @media screen and (max-width: 740px) {
    width: 100%;
    margin-right: 0;
  }
`;

export const ContainerUseCase = styled(Box)`
  display: flex;
  margin: 0 auto;
  gap: 180px;
  width: 100%;
`;

export const StyledContainer = styled(Box)`
  width: 90%;
  background-color: #ffffff;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  border-radius: 16px;
  padding: 50px;
  box-shadow: ${saasModernTheme.gradiantShadow};
  display: flex;
  @media screen and (max-width: 600px) {
    padding: 20px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-top: 50px;
  gap: 50px;
`;

export const ContentLeft = styled.div`
  display: flex;
  align-items: center;
  width: 50%;
  justify-content: center;
  @media screen and (max-width: 950px) {
    width: 100%;
  }
`;

export const ImageWrapper = styled.div`
  width: 400px;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 10px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media screen and (max-width: 950px) {
    width: 90%;
    height: auto;
  }
`;

export const ContentRight = styled.div`
  flex: 1;
  width: 50%;
`;

export const SectionTitle = styled.h3`
  font-weight: bold;
  margin-bottom: ${saasModernTheme.space[2]}px;
  color: var(--Text-Primary, #111927);
  font-family: ${saasModernTheme.fontFamily};
  font-size: 1.5rem;

  strong {
    background: ${saasModernTheme.customColor.gradiantColor};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    display: inline;=
  }
`;

export const Description = styled.div`
  margin-bottom: ${saasModernTheme.space[2]}px;
  font-family: ${saasModernTheme.fontFamily};
  color: var(--Text-Secondary, #636f81);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: -0.32px;

  ul {
    list-style-type: none;
    padding-left: 0;
  }

  li {
    position: relative;
    padding-left: 30px;
    margin-bottom: 12px;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 20px;
      height: 20px;
      background-color: #ff4d4d;
      border-radius: 50%;
      background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 12px;
    }
  }
`;

export const BenefitsList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin-bottom: ${saasModernTheme.space[3]}px;

  li {
    margin-bottom: ${saasModernTheme.space[1]}px;
    &::before {
      content: '✓';
      color: ${saasModernTheme.colors.success};
      margin-right: ${saasModernTheme.space[1]}px;
    }
  }
`;

export const Button = styled.button`
  background-color: ${saasModernTheme.defaultBackgroundColor};
  color: ${saasModernTheme.colors.white};
  padding: ${saasModernTheme.space[2]}px ${saasModernTheme.space[3]}px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-weight: bold;

  &:hover {
    background-color: ${saasModernTheme.customColor.gradiantColor};
  }
`;

export const BtnCTA = styled.button`
  border-radius: 12px;
  border: none;
  background: ${saasModernTheme.defaultBackgroundColor};
  color: white;
  padding: 12px 16px;
  font-family: ${saasModernTheme.fontFamily};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;

  &:hover {
    background: ${saasModernTheme.customColor.gradiantColor};
  }
`;

export const StyledLink = styled.a`
  text-decoration: none !important;
  color: inherit;
  display: inline-block;
`;
